var _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#313c4f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 60,
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 15,
    to: 15,
    begin: "0s",
    dur: "2s",
    values: "0;15;0;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 9
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 15,
    to: 15,
    begin: ".15s",
    dur: "2s",
    values: "0;15;0;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 60,
    r: 15
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 15,
    to: 15,
    begin: ".3s",
    dur: "2s",
    values: "0;15;0;0",
    calcMode: "linear",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.b26a595f0130a2d5a3e25df6a8994c56.svg";
export { ForwardRef as ReactComponent };